import React from 'react';
import PurchasingAgentDashboard from '../components/Purchases/PurchasingAgentDashboard';

const PurchasingAgentPage: React.FC = () => {
    return <PurchasingAgentDashboard />;
};

export default PurchasingAgentPage;
